import { ContentLayout } from "layouts";
import { CategoriesLists, useCategoriesNavigation } from "modules/categories";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "ui";

const NewProductSelectCategory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { subChildCategoryId } = useCategoriesNavigation();

  const navigateToCreateProduct = () => {
    navigate(`/products/create/${subChildCategoryId}`);
  };

  return (
    <ContentLayout
      title={t("Product Category")}
      action={
        <Button
          disabled={!subChildCategoryId}
          onClick={navigateToCreateProduct}
        >
          {t("Continue")}
        </Button>
      }
    >
      <CategoriesLists isViewMode />
    </ContentLayout>
  );
};

export default NewProductSelectCategory;
